import { queryOptions, useQuery } from '@tanstack/react-query';

import { mediaFolderApi } from '../api/media-api';

import { mediaKeys } from './media-keys';

/** Every folder of the organization in one response; the backend caps them at 200. */
export function mediaFoldersQueryOptions() {
  return queryOptions({
    queryKey: mediaKeys.folders(),
    queryFn: () => mediaFolderApi.list(),
    select: (data) => data.items,
  });
}

export function useMediaFolders() {
  return useQuery(mediaFoldersQueryOptions());
}
